import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Home from 'containers/Home';

const App = () => (
  <Router>
    <Switch>
      <Route component={Home} />
    </Switch>
  </Router>
);

export default App;
